module.exports = __webpack_public_path__ + "static/media/sms_alert.e4b3f3c3.jpg";